
import '../scss/Home.css';
import React, {useEffect, useState} from 'react';
import Navbar from './navbar/Navbar';
import CountAnimation from '../Logic/CounterAnimation';
// import { NavLink } from 'react-router-dom';
const Home = () => {
  const pageName=  "Dashboard"; 

  // User Data
  const data = {
    userData: {
      username: "Prashant",
      profilePic: "https://avatars.githubusercontent.com/u/43730425?v=4",
      totalNotification: 101,
    }
  }

  // Book Object
  const popularBooks = [
    {
      id: 1,
      name: 'The Edge',
      author: 'F. Scott Fitzgerald',
      imageUrl: 'https://static-cse.canva.com/blob/1040417/1024w-bpueJw9ttIE.jpg'
    },
    {
      id: 2,
      name: 'Hopeless',
      author: 'Harper Lee',
      imageUrl: 'https://uploads-ssl.webflow.com/625528df065c53d23c2bc83b/62723739bb391754b16b4f3a_wattpad-3.png'
    },
    {
      id: 3,
      name: 'King Arthur',
      author: 'George Orwell',
      imageUrl: 'https://d1csarkz8obe9u.cloudfront.net/posterpreviews/medieval-fantasy-wattpad-cover-design-template-fb3bc31853ee33845878b1bbd8f5b3b0_screen.jpg?ts=1637003247'
    },
    {
      id: 4,
      name: 'Love Story',
      author: 'Jane Austen',
      imageUrl: 'https://marketplace.canva.com/EAFGkIqRQvw/2/0/1003w/canva-watercolor-love-story-book-cover-Pqcyp1HUafk.jpg'
    },
    {
      id: 5,
      name: 'Love',
      author: 'J.D. Salinger',
      imageUrl: 'https://i.pinimg.com/originals/ee/09/89/ee0989b65722bdfba954345642113fe4.jpg'
    },
    {
      id: 6,
      name: 'Beyond The Year',
      author: 'J.R.R. Tolkien',
      imageUrl: 'https://i.pinimg.com/originals/81/4b/39/814b39fe272e82bcc2c6c9c489ffd036.png'
    },
    {
      id: 7,
      name: 'Before The Dawn',
      author: 'J.R.R. Tolkien',
      imageUrl: 'https://i.pinimg.com/originals/be/c9/e8/bec9e8457f1e1d268f85990c88d7fc5e.png'
    },
    {
      id: 8,
      name: 'Requem',
      author: 'C.S. Lewis',
      imageUrl: 'https://i.pinimg.com/474x/e2/2a/7d/e22a7d54e62e4c4cab4e66a3eb3a4010--book-covers-muse.jpg'
    }
  ];

  const Stats = [
    { icon: "fad fa-user", value: "28,866", label: "Book Author", count: 8906 },
    { icon: "fas fa-book-reader", value: "28,866", label: "Reader", count: 112 },
    { icon: "fad fa-share-alt", value: "28,866", label: "Shares", count: 1389 }
  ];

  const authorprofile = [
    { name: 'John', imageUrl: 'https://w0.peakpx.com/wallpaper/751/41/HD-wallpaper-women-mood-girl-portrait-profile-sunset.jpg' },
    { name: 'Jane', imageUrl: 'https://i.pinimg.com/736x/e6/4b/13/e64b13cbacb4d10ce5ea7f74de59c7a6.jpg' },
    { name: 'Bob', imageUrl: 'https://thumbs.dreamstime.com/b/poor-indian-boy-sad-serious-eyes-looks-camera-pondichery-puducherry-tamil-nadu-india-september-circa-122840383.jpg' },
    { name: 'Alice', imageUrl: 'https://diligentcreator.tech/dashboard/profile_images/1.66725004714E+12enally.in-Developer-resume.jpeg' },
    { name: 'Mark', imageUrl: 'https://c4.wallpaperflare.com/wallpaper/619/886/339/indian-women-smiling-face-wallpaper-preview.jpg' },
    { name: 'Samantha', imageUrl: 'https://wallpaperaccess.com/full/1948617.jpg' },
    { name: 'Mike', imageUrl: 'https://downloadwap.com/thumbs2/wallpapers/p2ls/new/41/ni_ynw2ZXrcZe.jpg' },
    { name: 'Emily', imageUrl: 'https://i.pinimg.com/236x/d9/6f/06/d96f0654244ae95fdcb5dd1b0d484435.jpg' },
    { name: 'Tom', imageUrl: 'https://i.pinimg.com/736x/db/b8/c6/dbb8c672c0faf3064a01d889524a4531.jpg' },
  ];
  
  

  const [currentProjectIndex, setCurrentProjectIndex] = useState(0);
  
  const projects = ["Classroom Bucket", "Diligent Creator", "Bulk Email Bot", "Bulk Image Dowloader", "Classroom Bot", "Python Pair Game", "Bulk Email Bot - GUI","Weather App"];

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentProjectIndex((currentProjectIndex + 1) % projects.length);
    }, 5000);
    return () => clearInterval(intervalId);
  }, [currentProjectIndex, projects.length]);

  
  return (
    <div className='Home'>
      <Navbar data={data} pageName={pageName} />

      <div className='Card-Body'>
        {/* Stats section */}
        {Stats.map((item, index) => (
          <div className='Card' key={index}>
            <div className='left'>
              <i className={item.icon}></i>
            </div>
            <div className='right'>
              <h2>{item.value}</h2>
              <p>{item.label}</p>
            </div>
            <div className='eright'>
              <h2>+<CountAnimation targetCount={item.count} /></h2>
            </div>
          </div>
        ))}

        {/* Sidebar Search option */}
        <div className='Search-Blog'>
          <input type="text" placeholder='Subscribe To Our Blog' />
          <button><i className="fal fa-envelope"></i></button>
        </div>
      </div>

      <div className='Content-Body'>

        <div className="left">
          <div className='heading-options'>
            <p>Popular Book</p>
            <div className='icon'>
              <i class="fas fa-ellipsis-h"></i>      
            </div>
          </div>
          <div className='Card-Body'>
            {popularBooks.map(book => (
              <div className='Card' key={book.id}>
                <img src={book.imageUrl} alt='bookimage' />
                <p className='book-name'>{book.name}</p>
                <span className='author-name'>{book.author}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="right">
          <div className='Poster'>
            <img src="https://enally.in/cdn/globalImages/CLASSROOM%20BUCKETAn.gif" alt="poster" />
            <p className='project'>{projects[currentProjectIndex]}</p>
          </div>

          <div className='Ritems'>
            <div className='Top'>
              <p>Authors</p>
              <i class="fas fa-ellipsis-h"></i>
            </div>
            
            <div className='Item'>
              {authorprofile.map((user, index) => (
                  <img title={user.name} src={user.imageUrl} alt={`user-${index}`} key={`user-${index}`} />
              ))}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Home;
